import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays } from 'date-fns';

@Pipe({ name: 'baseDaysDifference' })
export class BaseDaysDifferencePipe implements PipeTransform {
  transform(dateTo: string, dateFrom: string): number {
    return differenceInDays(new Date(dateTo), new Date(dateFrom)) + 1;
  }
}
